import "core-js/modules/es.array.fill.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  width: "25",
  height: "26",
  viewBox: "0 0 25 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var _hoisted_2 = ["fill"];
var _hoisted_3 = ["fill"];

var _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.1014 9.95404C11.9786 10.0049 11.8635 10.0802 11.7636 10.1801L8.63859 13.3051C8.2318 13.7119 8.2318 14.3714 8.63859 14.7782C9.04539 15.185 9.70494 15.185 10.1117 14.7782L11.4585 13.4315V18.2083C11.4585 18.7836 11.9249 19.25 12.5002 19.25C13.0755 19.25 13.5418 18.7836 13.5418 18.2083V13.4315L14.8886 14.7782C15.2954 15.185 15.9549 15.185 16.3617 14.7782C16.7685 14.3714 16.7685 13.7119 16.3617 13.3051L13.2367 10.1801C12.9298 9.87317 12.479 9.79782 12.1014 9.95404Z",
  fill: "white"
}, null, -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, [_createElementVNode("path", {
    opacity: "0.25",
    d: "M3.125 4.66675C3.125 2.94086 4.52411 1.54175 6.25 1.54175H16.4139C17.2427 1.54175 18.0376 1.87099 18.6236 2.45704L20.9597 4.79312C21.5458 5.37917 21.875 6.17403 21.875 7.00283V21.3334C21.875 23.0593 20.4759 24.4584 18.75 24.4584H6.25C4.52411 24.4584 3.125 23.0593 3.125 21.3334V4.66675Z",
    fill: $props.fill
  }, null, 8, _hoisted_2), _createElementVNode("path", {
    d: "M15.625 2.47071C15.625 1.95766 16.0409 1.54175 16.554 1.54175V1.54175C17.2931 1.54175 18.002 1.83537 18.5246 2.35801L21.0587 4.89215C21.5814 5.4148 21.875 6.12365 21.875 6.86278V6.86278C21.875 7.37584 21.4591 7.79175 20.946 7.79175H16.6667C16.0914 7.79175 15.625 7.32538 15.625 6.75008V2.47071Z",
    fill: $props.fill
  }, null, 8, _hoisted_3), _hoisted_4]);
}